import { render, staticRenderFns } from "./Jaarverslagen.vue?vue&type=template&id=234cd03c&scoped=true"
import script from "./Jaarverslagen.vue?vue&type=script&lang=ts"
export * from "./Jaarverslagen.vue?vue&type=script&lang=ts"
import style0 from "./Jaarverslagen.vue?vue&type=style&index=0&id=234cd03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234cd03c",
  null
  
)

export default component.exports